import React, { useState } from 'react';
import { TableIds } from 'src/api/types/misc';
import { InputLabel, NoData, Poppins } from 'src/common';
import Audit from 'src/components/Audit';
import ExpandSection from 'src/components/ExpandSection';
import { ScenarioQuery } from 'src/graphql/_generated';
import { formatDate } from 'src/utils/misc';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 25px;

  .item {
    display: flex;
    align-items: center;
    grid-gap: 8px;
  }
`;

interface AuditSectionProps {
  versionId?: string;
  scenario: NonNullable<ScenarioQuery['scenario']>;
}

export const AuditSection: React.FC<AuditSectionProps> = ({ versionId, scenario }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ExpandSection
      title="ACTIVITY"
      defaultOpen={false}
      onChange={setIsOpen}
      sectionId="scenario_audit"
      endComponent={
        <Div>
          <div className="item">
            <InputLabel>EDITED:</InputLabel>
            {scenario.editedAt ? (
              <Poppins px={14} weight={500}>
                {formatDate(scenario.editedAt, { formatType: 'datetime' })}
              </Poppins>
            ) : (
              <NoData />
            )}
          </div>
          <div className="item">
            <InputLabel>UPDATED:</InputLabel>
            <Poppins px={14} weight={500}>
              {formatDate(scenario.meta?.updatedAt, { formatType: 'datetime' })}
            </Poppins>
          </div>
        </Div>
      }
    >
      {isOpen && (
        <div
          style={{
            maxHeight: '800px',
            position: 'relative',
          }}
        >
          <Audit
            rootPath="scenarios"
            initQuery={{ version: versionId, scenario_id: scenario.id }}
            tableId={TableIds.auditScenario}
            noHide
            topSpacer={0}
            maxHeight={800}
            toolbar
          />
        </div>
      )}
    </ExpandSection>
  );
};
